<template>
<div class="default-page">
	<Navigation></Navigation>

	<router-view class="content" :key="$route.fullPath"></router-view>

	<v-alert v-if="alerts.length > 0" :value="true" :type="alerts[0].success ? 'success' : 'error'">
		{{alerts[0].message}}
		<v-icon @click="deleteAlert(0)">check</v-icon>
	</v-alert>

	<v-alert v-if="alerts.length > 1" class="alert1" :value="true" :type="alerts[1].success ? 'success' : 'error'">
		{{alerts[1].message}}
		<v-icon @click="deleteAlert(1)">check</v-icon>
	</v-alert>

	<v-alert v-if="alerts.length > 2" class="alert2" :value="true" :type="alerts[2].success ? 'success' : 'error'">
		{{alerts[2].message}}
		<v-icon @click="deleteAlert(2)">check</v-icon>
	</v-alert>

	<v-dialog v-model="privateModalOpen" max-width="800">
		<v-card>
			<component v-if="modalContent" v-bind:is="modalContent.name" :params="modalContent.params"></component>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import Navigation from './navigation.vue'
import SendSubBot from '../components/modals/sendSubBot.vue'

// import modal componentns

import { CLEAN_ALERT, CLOSE_MODAL } from '../variables'

export default {
	components: { Navigation, SendSubBot},
	data() {
		return {
			privateModalOpen: false
		}
	},
	methods: {
		deleteAlert(value) {
			this.$store.dispatch(CLEAN_ALERT, value)
		}
	},
	computed: {
		alerts() {
			return this.$store.getters.alerts
		},
		modalOpen() {
			return this.$store.getters.modalOpen
		},
		modalContent() {
			return this.$store.getters.modalContent
		}
	},
	watch: {
		modalOpen() {
			this.privateModalOpen = this.modalOpen
		},
		privateModalOpen(newValue, oldValue) {
			if (!this.privateModalOpen) {
				this.$store.dispatch(CLOSE_MODAL)
			}
		}
	}
}
</script>

<style lang="scss">
.default-page {
    min-height: 100vh;
    height: 100vh;
    display: flex;

    .content {
        max-width: 95%;
        overflow-x: auto;
    }

    .v-alert {
        bottom: 0;
        right: 0;
        position: fixed;

        &.alert1 {
            bottom: 70px;
        }

        &.alert2 {
            bottom: 140px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/baseComponents/defaultPage.vue